// extracted by mini-css-extract-plugin
export var orderDetails = "_u8-2";
export var orderImage = "_u8-1";
export var orderMeta = "_u8-3";
export var orderSummary = "_u8-0";
export var rightArrow = "_u8-4";